import React from 'react';
import {Link} from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Home = () => {
  const services = [
    {
      icon: FiIcons.FiTool,
      title: 'Mantenimiento Informático',
      description: 'Servicio técnico y mantenimiento preventivo para sus equipos.',
      path: '/servicios/mantenimiento'
    },
    {
      icon: FiIcons.FiShield,
      title: 'Ciberseguridad',
      description: 'Protección avanzada contra amenazas y gestión de seguridad.',
      path: '/servicios/ciberseguridad'
    },
    {
      icon: FiIcons.FiCloud,
      title: 'Cloud y Hosting',
      description: 'Soluciones cloud escalables y servicios de hosting profesional.',
      path: '/servicios/cloud'
    },
    {
      icon: FiIcons.FiBrain,
      title: 'Inteligencia Artificial',
      description: 'Automatización y optimización de procesos con IA avanzada.',
      path: '/servicios/ia'
    },
    {
      icon: FiIcons.FiCpu,
      title: 'Soporte Técnico',
      description: 'Resolución rápida de incidencias y asistencia técnica especializada.',
      path: '/servicios/soporte'
    },
    {
      icon: FiIcons.FiMonitor,
      title: 'Hardware',
      description: 'Venta y asesoramiento de equipos informáticos profesionales.',
      path: '/servicios/hardware'
    }
  ];

  return (
    <div className="relative">
      {/* Hero Section - Único H1 de la página */}
      <section className="relative text-white py-20 animated-gradient">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              Deja la tecnología en nuestras manos y dedícate a hacer crecer tu negocio
            </h1>
            <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto">
              Ofrecemos soluciones informáticas integrales para pymes. Garantizamos que tus sistemas funcionen siempre de manera óptima y segura, liberándote de las preocupaciones técnicas.
            </p>
            <Link to="/contacto" className="inline-block bg-white text-blue-600 px-8 py-3 rounded-lg font-semibold hover:bg-blue-50 transition-colors">
              Solicita tu Consulta Gratuita
            </Link>
          </div>
        </div>
      </section>

      {/* AI Section - H2 */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-12">
            Expertos en Inteligencia Artificial
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <SafeIcon icon={FiIcons.FiCpu} className="h-12 w-12 text-blue-600 mb-4 mx-auto" />
              <h3 className="text-xl font-semibold mb-2 text-center">Machine Learning</h3>
              <p className="text-gray-600 text-center">
                Algoritmos de aprendizaje que optimizan sus procesos empresariales
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <SafeIcon icon={FiIcons.FiMessageSquare} className="h-12 w-12 text-blue-600 mb-4 mx-auto" />
              <h3 className="text-xl font-semibold mb-2 text-center">Chatbots Inteligentes</h3>
              <p className="text-gray-600 text-center">
                Asistentes virtuales para atención al cliente 24/7
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <SafeIcon icon={FiIcons.FiTrendingUp} className="h-12 w-12 text-blue-600 mb-4 mx-auto" />
              <h3 className="text-xl font-semibold mb-2 text-center">Análisis Predictivo</h3>
              <p className="text-gray-600 text-center">
                Predicción de tendencias y comportamientos mediante IA
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Servicios Section - H2 */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-12">
            Nuestros Servicios Principales
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {services.map((service, index) => (
              <div key={index} className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow">
                <SafeIcon icon={service.icon} className="h-10 w-10 text-blue-600 mb-4" />
                <h3 className="text-xl font-semibold mb-2">{service.title}</h3>
                <p className="text-gray-600 mb-4">{service.description}</p>
                <Link to={service.path} className="text-blue-600 font-semibold hover:text-blue-800 flex items-center">
                  Más información <SafeIcon icon={FiIcons.FiArrowRight} className="ml-2" />
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Por qué elegirnos - H2 */}
      <section className="bg-gray-50 py-16">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-12">
            ¿Por Qué Elegir VGBComputers?
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="flex items-start">
              <div className="bg-blue-600 rounded-full p-3 mr-4">
                <SafeIcon icon={FiIcons.FiClock} className="h-6 w-6 text-white" />
              </div>
              <div>
                <h3 className="text-xl font-semibold mb-2">Respuesta rápida</h3>
                <p className="text-gray-600">Soporte técnico con tiempo de respuesta garantizado para minimizar interrupciones.</p>
              </div>
            </div>
            <div className="flex items-start">
              <div className="bg-blue-600 rounded-full p-3 mr-4">
                <SafeIcon icon={FiIcons.FiAward} className="h-6 w-6 text-white" />
              </div>
              <div>
                <h3 className="text-xl font-semibold mb-2">Experiencia probada</h3>
                <p className="text-gray-600">Más de 20 años de experiencia en el sector informático en Tenerife.</p>
              </div>
            </div>
            <div className="flex items-start">
              <div className="bg-blue-600 rounded-full p-3 mr-4">
                <SafeIcon icon={FiIcons.FiUsers} className="h-6 w-6 text-white" />
              </div>
              <div>
                <h3 className="text-xl font-semibold mb-2">Equipo especializado</h3>
                <p className="text-gray-600">Profesionales certificados en las tecnologías más avanzadas del mercado.</p>
              </div>
            </div>
            <div className="flex items-start">
              <div className="bg-blue-600 rounded-full p-3 mr-4">
                <SafeIcon icon={FiIcons.FiLayers} className="h-6 w-6 text-white" />
              </div>
              <div>
                <h3 className="text-xl font-semibold mb-2">Soluciones a medida</h3>
                <p className="text-gray-600">Servicios personalizados adaptados a las necesidades específicas de su empresa.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonios - H2 */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-12">
            Testimonios de Clientes Satisfechos
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <div className="flex items-center mb-4">
                <SafeIcon icon={FiIcons.FiUser} className="h-12 w-12 text-blue-600 mr-4 bg-blue-100 p-2 rounded-full" />
                <div>
                  <h3 className="font-semibold">Miguel Ángel Rguez.</h3>
                  <p className="text-gray-600">CEO, Centro Médico La Cuesta</p>
                </div>
              </div>
              <p className="text-gray-600 italic">
                "VGBComputers transformó nuestra infraestructura IT, mejorando significativamente nuestra productividad."
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <div className="flex items-center mb-4">
                <SafeIcon icon={FiIcons.FiUser} className="h-12 w-12 text-blue-600 mr-4 bg-blue-100 p-2 rounded-full" />
                <div>
                  <h3 className="font-semibold">Fernando Trujillo</h3>
                  <p className="text-gray-600">Gerente, Tránsitos Trujillo</p>
                </div>
              </div>
              <p className="text-gray-600 italic">
                "Su servicio de mantenimiento preventivo nos ha ahorrado tiempo y dinero en resolución de problemas."
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;